import { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { BookingPage } from './BookingPage';

/** Public, login-free booking app served on book.digitalbaxter.com. */
export function PublicBookingApp() {
  // The Limitless theme locks document scrolling (`html { overflow: hidden }`) for the
  // fixed-sidebar app shell. The public booking pages scroll the document directly, so
  // re-enable normal scrolling on the booking host (fixes unscrollable pages on mobile).
  useEffect(() => {
    document.documentElement.classList.add('booking-host');
    return () => document.documentElement.classList.remove('booking-host');
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:slug" element={<BookingPage />} />
        <Route
          path="*"
          element={
            <div className="d-flex vh-100 align-items-center justify-content-center text-muted">
              This is a booking host. Open a specific booking link.
            </div>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
